import type {ReactElement} from 'react';
import type {CustomLineItemControlsWrapperProps} from './custom-line-item-controls-wrapper.types';
import {CustomLineItemControlMr} from '@Components/poster-editor/components/custom-line-item-controls-wrapper/components/custom-line-item-control-mr/custom-line-item-control-mr';
import {CustomLineItemControlMl} from '@Components/poster-editor/components/custom-line-item-controls-wrapper/components/custom-line-item-control-ml/custom-line-item-control-ml';
import {useAppSelector} from '@/hooks';
import {useSingleActivePosterItemId} from '@Hooks/poster-editor/useSingleActivePosterItemId';

export function CustomLineItemControlsWrapper(
  {
    ...props
  }: CustomLineItemControlsWrapperProps): ReactElement<any>| null {
  const activeItemId = useSingleActivePosterItemId() ?? '';
  const shouldHideControls = useAppSelector((state) => {
    return state.posterEditor.shouldHideControls[activeItemId];
  });
  if (shouldHideControls) {
    return null;
  }

  const page = window.posterEditor?.whiteboard?.pages.getPage(props.pageHashedId);
  if (!page) {
    return null;
  }
  const activeSelection = page.activeSelection.getActiveObject();
  if (!activeSelection) {
    return null;
  }

  return (
    <div>
      <CustomLineItemControlMl pageHashedId={props.pageHashedId} positionProperties={props.positionProperties}/>
      <CustomLineItemControlMr pageHashedId={props.pageHashedId} positionProperties={props.positionProperties}/>
    </div>
  );
}